import moment from 'moment';

// Valid account group IDs - maintained in backend (bbcedit_web/bbwebapi/config/accountGroups.js)
// This list must be kept in sync with backend config.
const VALID_ACCOUNT_GROUP_IDS = [
  'blackboiler',
  'admin',
  'user',
  'playbook_builder',
  'group_metrics',
  'fasttrack_metrics',
  'clause_editor',
  'bullseye',
  'fasttrack',
  'poa_intake',
  'poa_review',
  'poa_manage',
  'accountmanager',
  'answer_question',
  'tier1',
  'tier2',
  'tier3',
];

export const truthy = (val) => ['True', 'TRUE', 'true', true, 'y', 'yes'].includes(val);
export const falsey = (val) =>
  ['False', 'FALSE', 'false', false, 'n', 'no'].includes(val);
export const isBool = (val) => truthy(val) || falsey(val);

export const isDate = (val) => Date.parse(val);
export const isFormattedDate = (val) =>
  Date.parse(val) && moment(Date.parse(val)).format('MMMM D, YYYY');
export const formatDateToStandard = (val) => moment(val).format('MMMM D, YYYY');
export const formatDateToStandardDateTime = (val) =>
  moment(val).format('MMMM D, YYYY LT');

export const getValidRoles = (roles) => {
  return roles.reduce((acc, role) => {
    if (VALID_ACCOUNT_GROUP_IDS.includes(role._id)) {
      acc.push(role);
    }
    return acc;
  }, []);
};

/** Convert time to duration
 *
 * Time will be number. It can be string or number. exp: ('123', '12.3', 123)
 *
 * Type ('seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'years')
 */
export const convertTimeToDuration = (time, type) => {
  if (time === 0 || time === '0') {
    return '-';
  }

  const durationTime = moment.duration(time, type).humanize();
  return durationTime;
};

export const convertOnlyOfficeErrorMessage = (code) => {
  switch (code) {
    case -1:
      return 'Unknown error';
    case -2:
      return 'Conversion timeout error';
    case -3:
      return 'Conversion error';
    case -4:
      return 'Error while downloading the document file to be converted';
    case -5:
      return 'Incorrect password';
    case -6:
      return 'Error while accessing the conversion result database';
    case -7:
      return 'Input error';
    case -8:
      return 'Invalid token';
    default:
      return `Error code: ${code}`;
  }
};
